import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { Col, Container, Row, Form, FormControl, FormGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Blockquote from '../../components/Blockquote';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../components/Checkbox/CheckboxGroup';
import GenericCard from '../../components/GenericCards';
import Link from '../../components/Link';
import Radio, { RadioGroup } from '../../components/Radio';
//import { RadioGroup } from '../../components/Radio';
import RadioWithImage from '../../components/RadioWithImage';
import Select from '../../components/Select';
import SelectableBankCard from '../../components/SelectableBankCard/SelectableBankCard';
import SelectableDefaultBankCard from '../../components/SelectableBankCard/SelectableDefaultBankCard';
import Switch from '../../components/Switch';
import TextInput from '../../components/TextInput/TextInput';
import Chip from '../../components/TransactionStatus';
import useModal from '../../hooks/useModal';
import { PAYMENT_INFO_ROUTE, PROFILE_ROUTE } from '../../routes/types';
import { getAllStates } from '../../services/states';
import {
  addOrRemoveMonthsToGivenDate,
  DateFormats,
  formatDate,
  formatPrice,
} from '../../utils/utils';
import PayNowCreditActionRequiredSummary from '../widgets/PaymentInformation/PayNowCreditActionRequiredSummary';
import AddNewBankModal from '../widgets/retireOnlineModals/addNewBankModal/AddNewBankModal';
import { ModalManagementStore } from '../../providers/modal-manager';

const radioCards = [
  {
    imageRef: 'debit-card.png',
    cardTitle: 'Credit / Debit Card',
    cardSubtitle: 'Fees Apply',
    id: 'debit-card',
  },
  {
    imageRef: 'bank-transfer.png',
    cardTitle: 'Bank Transfer',
    cardSubtitle: 'Transfer from bank account',
    id: 'bank-transfer',
    chip: (
      <div className="mt-1">
        <Chip variant={'completed'}>Auto-Pay Avaible</Chip>
      </div>
    ),
  },
  {
    imageRef: 'check-money.png',
    cardTitle: 'Check / Money Order',
    cardSubtitle: 'Mail In',
    id: 'check-money',
  },
];

const directDepositData = {
  selectedBankOption: '1',
  selectedBank: {
    id: '1',
    name: 'Wells Fargo Bank',
    iban: '1234123412',
    routingNumber: '034802454',
    accountNumber: '43214321',
    type: 'Savings',
  },
  banksOptions: [
    {
      id: '1',
      name: 'Wells Fargo Bank',
      iban: '1234123412',
      routingNumber: '034802454',
      accountNumber: '43214321',
      type: 'Savings',
    },
    {
      id: '2',
      name: 'Bank of America',
      iban: '4321432143',
      routingNumber: '034804444',
      accountNumber: '12341234',
      type: 'Cheking',
    },
  ],
};

const banksDetails = [
  { id: '1', name: 'Wells Fargo Bank', iban: '1234123412' },
  { id: '2', name: 'Bank of America', iban: '1234123412' },
];

const PayNow = () => {
  const [userInputValue, setUserInputValue] = useState<number | undefined | null >(1);
  const handleChangePayInputValue = (value: number | undefined | null) => {
    if (typeof value === 'number') {
      const roundedValue = Number(value.toFixed(2)); // Round to 2 decimal places
      setUserInputValue(roundedValue);
    } else {
      setUserInputValue(value);
    }
  };
  //const [payValue, setPayValue] = useState<number | undefined | null >(332);
  const totalValue = formatPrice(332.00);
  const payValue = formatPrice(332.00);
  const [
    showAddNewBank,
    handleShowAddNewBankModal,
    handleCloseAddNewBankModal,
  ] = useModal();
 
  const [cardOption, setCardOption] = useState<string | number>('');
  const [payOption, setPayOption] = useState<string | number>('');
  const [approvalCheckbox, setApprovalCheckbox] = React.useState<string[]>([]);
  const [data, setData] = useState(directDepositData);

  const navigate = useNavigate();
  const { openModal } = useContext(ModalManagementStore);

  const handleNewBank = (bank: any) => {
    setData({
      ...data,
      banksOptions: [...data.banksOptions, bank],
    });
  };

  const handleChange = (e: string | number) => {
    setCardOption(e);
  };

  const handleChangePay = (e: string | number) => {
    setPayOption(e);

  };

  const handleOnTermsCheckboxValueCahnge = (event: any, values: string[]) => {
    setApprovalCheckbox(values);
  };

  const statesOptions = getAllStates();

  const [value, setValue] = useState<string | number>('');

  const handleChangeBankCard = (e: string | number) => {
    setValue(e);
  };

  

  const getUserInputInteger = () => {
    return userInputValue ? userInputValue : 1;
  };

  return (
    <Container className="cnd-custom-container px-7 px-lg-0 pt-lg-12 mt-11 mt-lg-12">
      <h5>How would you like to pay?</h5>
      <Row className={'mt-7 mt-lg-13'}>
        <Col sm={12} lg={8} className={'p-0 d-flex flex-column px-10'}>

        <Row className="ps-10 mb-10 w-100">
        <GenericCard variant={'white'}>
            <Col className={'col-12'}>
             
              <div>
              <div
                className={'text-light-grey text-fs-6 fw-light text-lg-start'}
              >
                {`Due:  ${formatDate(
                  addOrRemoveMonthsToGivenDate(
                    new Date(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      1
                    ),
                    1
                  ),
                  DateFormats.SHORT_MONTH_DAY_YEAR
                )}`}
              </div>
            <RadioGroup
              name={'payOptions'}
              value={payOption}
              onChange={handleChangePay}
            >
              <Radio
                value={'payTotal'}
                id={'pay-1'}
                label={'My total outstanding balance: '+ totalValue}
                className={'mt-10'}
              />
              <Radio
                value={'otherAmount'}
                id={'pay-2'}
                label={'Other amount:'}
                className={'mt-10'}
              />
              {payOption === 'otherAmount' && (
               <Row>
                <Col className={'ms-11 pe-11 col-12 col-md-6 col-lg-4'}>
                  <FormGroup className={`number-input-custom`}>
                  <div className="input-wrapper">
                    <FontAwesomeIcon icon={light('dollar')} className={`icon`} />
                    <FormControl
                      type={'number'}
                      value={(userInputValue?.toFixed(2)) || '1.00'}
                      onChange={(e) => handleChangePayInputValue(Number(e.target.value))}
                    />
                  </div>
                  </FormGroup>

                  </Col>
                  <Col className={'ms-11 pe-11 col-12 col-lg-12'}>
                      <Form.Text id="passwordHelpBlock" className={'text-light-grey text-fs-6 fw-light text-lg-start pt-3 d-block'} muted>Range: $1.00 - {payValue}</Form.Text>
                      <div className="custom-blockquote primary warning mt-4 text-light-grey text-fs-6 fw-light text-lg-start">Note: paying less than the past due amount may result in loss of coverage or denial of claims.<br/><br/><span className='fw-bold'>!Important</span> Due to bank payment processing, making a partial payment now may prevent you from making another payment before the payment due date.</div>
                  </Col>
              </Row>
              )}
            </RadioGroup>
          </div>
             
              
            </Col>
          </GenericCard>
          </Row>

          <Row className="m-0 w-100">
            <RadioGroup
              name={'no-labels'}
              value={cardOption}
              onChange={handleChange}
            >
              {radioCards.map((radioCard, idx) => {
                return (
                  <Col
                    key={idx}
                    className={`p-0 mt-7 mt-lg-0 px-5 col-12 col-lg-4`}
                    style={{ minWidth: 220 }}
                  >
                    <RadioWithImage
                      key={idx}
                      cardData={radioCard}
                      selected={cardOption !== radioCard.id}
                      chip={radioCard.chip}
                      isBankDetailsCard
                      className="h-100"
                    />
                  </Col>
                );
              })}
            </RadioGroup>

            {cardOption === 'check-money' && (
              <PayNowCreditActionRequiredSummary />
            )}

            {cardOption === 'bank-transfer' && (
              <Col className={'mt-13 col-12'}>
                <GenericCard className={'px-10'} variant={'white'}>
                  <Row>
                    <Col className={'col-12'}>
                      <span>
                        Select from an existing account or add a new one
                      </span>
                    </Col>
                  </Row>
                  <Container className="p-0 mt-10 d-flex flex-wrap">
                    <RadioGroup
                      name={'test1'}
                      value={value}
                      onChange={handleChangeBankCard}
                    >
                      {banksDetails.map((bank, i) => (
                        <Col className={'me-7 col-12 col-lg-4'}>
                          <SelectableBankCard
                            variant={'transparent'}
                            key={i}
                            item={bank}
                            className={'mb-7 mb-lg-0 me-lg-7'}
                            selected={value === bank.id}
                          />
                        </Col>
                      ))}
                    </RadioGroup>
                    <SelectableDefaultBankCard
                      onClick={handleShowAddNewBankModal}
                    />
                    <AddNewBankModal
                      banks={directDepositData.banksOptions}
                      handleAddNewBank={handleNewBank}
                      showModal={showAddNewBank}
                      handleClose={handleCloseAddNewBankModal}
                    />
                  </Container>

                  <GenericCard className={'px-10 mt-12'}>
                    <Row>
                      <Col className={'col-12'}>
                        <h2
                          className={'fw-normal-sm-light-lg text-sm-16-lg-20'}
                        >
                          Would you like to enable Auto-Pay?
                        </h2>
                      </Col>
                      <Col className={'col-12 mt-7'}>
                        <Row className={'align-items-center'}>
                          <Col className={'col-12 col-lg-8'}>
                            <span className={'text-fs-6 fw-light'}>
                              With Auto-Pay you don't need to manually make your
                              payments every month.
                            </span>
                          </Col>
                          <Col className={'col-12 col-lg-4 mt-7 mt-lg-0'}>
                            <Switch
                              className={'d-flex justify-content-end'}
                              label={'Enable Autopay'}
                              isLeftLabel
                              labelColor={'blue-label'}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </GenericCard>

                  <Row className={'mt-12'}>
                    <Col className={'col-12'}>
                      <h2 className={'fw-normal-sm-light-lg text-sm-16-lg-20'}>
                        How would you like to receive Reminders?
                      </h2>
                    </Col>
                    <Col className={'col-12 mt-7'}>
                      <span className={'text-fs-6 fw-light'}>
                        Based on your
                        <span className={'d-inline-block'}>
                          <Link
                            href={`#${PROFILE_ROUTE.replace(
                              ':tab',
                              'communication'
                            )}`}
                            className={
                              'px-1 py-0 d-flex justify-content-space-between'
                            }
                            isBlue
                          >
                            Communication Center Preferences
                          </Link>
                        </span>
                        you'll receive a text message within 10 days of your
                        bill being due.
                      </span>
                    </Col>
                  </Row>
                </GenericCard>

                <Row className={'justify-content-center'}>
                  <Col className={'col-12 col-lg-3 mt-10 mt-lg-12 text-center'}>
                    <Container className={'px-0'}>
                      <Button
                        className={'w-100'}
                        onClick={() => navigate(PAYMENT_INFO_ROUTE)}
                      >{`Pay Now`}</Button>
                    </Container>
                  </Col>
                </Row>
              </Col>
            )}

            {cardOption === 'debit-card' && (
              <Col className={'mt-13 col-12'}>
                <GenericCard className={'px-10'} variant={'white'}>
                  <h6>Credit/Debit Card Information</h6>
                  <div className="mt-10">
                    <CheckboxGroup
                      name="approval"
                      value={approvalCheckbox}
                      onChange={handleOnTermsCheckboxValueCahnge}
                    >
                      <Checkbox
                        id={'1'}
                        name={'approve'}
                        value={'approve'}
                        variant="sm"
                        label={
                          'I Agree to the $10 convenience fee added to the total due.'
                        }
                      />
                    </CheckboxGroup>
                    <div className="mt-3 ms-9 ps-3 lh-xxs fw-light text-sub1">
                      <span>
                        Note: Convenience fee of $10 will appear separately on
                        your credit card statement.
                      </span>
                    </div>
                  </div>
                  {approvalCheckbox[0] && (
                    <div className="mt-10">
                      <Row className="m-0 justify-content-around">
                        <Col className="p-0 col-12 col-lg-5">
                          <TextInput label={'Name on Card'} />
                        </Col>
                        <Col className="p-0 col-12 col-lg-5 mt-7 mt-lg-0">
                          <TextInput
                            label={'Card Number'}
                            leftIcon={light('money-check-dollar')}
                            type="card"
                          />
                        </Col>
                      </Row>
                      <Row className="m-0 mt-7 mt-lg-10 justify-content-lg-around">
                        <Col className="p-0 d-flex flex-column flex-lg-row justify-content-lg-between col-12 col-lg-5">
                          <Col className="p-0 col-12 col-lg-5">
                            <TextInput
                              placeholder="MM/YY"
                              type="expiration"
                              label={'Expiration'}
                            />
                          </Col>
                          <Col className="p-0 col-12 col-lg-5 mt-7 mt-lg-0">
                            <TextInput
                              placeholder="CVC"
                              type="cvc"
                              label={'Security Code'}
                            />
                          </Col>
                        </Col>
                        <Col className="p-0 col-12 col-lg-5 mt-7 mt-lg-0"></Col>
                      </Row>
                      <h6 className="mt-12">Billing Address</h6>
                      <Row className="m-0 mt-lg-10 justify-content-around">
                        <Col className="p-0 col-12 col-lg-5">
                          <TextInput label={'Address 1'} />
                        </Col>
                        <Col className="p-0 col-12 col-lg-5 mt-7 mt-lg-0">
                          <TextInput label={'Address 2 (Optional)'} />
                        </Col>
                      </Row>
                      <Row className="m-0 mt-7 mt-lg-10">
                        <Col className="p-0  d-flex flex-column flex-lg-row justify-content-lg-around col-12">
                          <Col className="p-0 col-12 col-lg-3">
                            <TextInput label={'City'} />
                          </Col>
                          <Col className="p-0 col-12 col-lg-3 mt-7 mt-lg-0">
                            <Select
                              label="State"
                              options={statesOptions}
                              minWidth={'155px'}
                            />
                          </Col>
                          <Col className="p-0 col-12 col-lg-3 mt-7 mt-lg-0">
                            <TextInput label={'ZIP Code'} />
                          </Col>
                        </Col>
                      </Row>
                      <Row className="m-0 mt-11">
                        <Blockquote variant="warning-bg" lineVariant="warning">
                          <p className={'mb-0 text-ligther-grey fw-bolder'}>
                            <span>Convenience fee</span>
                          </p>
                          <div className={'mb-0 text-ligther-grey'}>
                            <span>
                              {`You're paying your total due of ${userInputValue !== null ? `Pay $${userInputValue}` : `Pay ${payValue}`} plus the $10.00 convenience fee.`}
                            </span>
                          </div>
                        </Blockquote>
                      </Row>
                    </div>
                  )}
                </GenericCard>
                <Row className={'justify-content-center'}>
                  <Col className={'col-12 col-lg-3 mt-10 mt-lg-12 text-center'}>
                    <Container className={'px-0'}>
                      <Button
                        key='pay-now'
                        className={'w-100'}
                        onClick={() => navigate(PAYMENT_INFO_ROUTE)}
                      >{`Pay Now`}</Button>
                    </Container>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Col>
        <Col sm={12} lg={4} className={'p-0 mt-11 mt-lg-0'}>
          
          <GenericCard className=" px-7 py-10 border rounded-1">
            <div className="text-sub1 text-ligther-grey lh-xxs">
              <div className="fw-bolder lh-xs">
                <span>Payment details</span>
              </div>
              <ul className="lh-xs ps-10">
                <li>
                  <span className="fw-bolder">
                    Credit / Debit Card (One-time)
                  </span>
                  <span className="fw-light">
                    : A $10 convenience fee will be added to the total due.
                  </span>
                </li>
                <li>
                  <span className="fw-bolder">
                    Bank Account (One-time/Auto-Pay)
                  </span>
                  <span className="fw-light">
                    : Select existing bank account or add new to make payment.
                    Auto-Pay available which eliminates the need to manually pay
                    each month.
                  </span>
                </li>
                <li>
                  <span className="fw-bolder">
                    Check / Money Order (One-time)
                  </span>
                  <span className="fw-light">
                    : Download/Print statement to mail in with your payment.
                  </span>
                </li>
              </ul>
            </div>
            <div className="mt-7 d-flex justify-content-end">
              <Button
                className="col-12 col-lg-7"
                variant="secondary-outline"
                size="sm"
                rightIcon={light('calendar-day')}
                onClick={() => openModal('payment-schedule')}
              >
                Payment Schedule
              </Button>
            </div>
          </GenericCard>
        </Col>
      </Row>
    </Container>
  );
};

export default PayNow;
